import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import setupAxios from './utils/axiosConfig';
import setupNative from './utils/native';
import setupOta from './utils/ota';
import { applyFont } from './utils/font';

setupAxios();
setupNative();
setupOta();
applyFont();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <BrowserRouter basename={process.env.PUBLIC_URL}>
    <App />
  </BrowserRouter>
  // </React.StrictMode>
);


reportWebVitals();
